import type { CompanionEvent } from '@edge/edge-ai'

interface EventBus {
  on(handler: (event: CompanionEvent) => void): () => void
}

/**
 * Call `onTurnEnd` each time a companion turn finishes, successfully or not.
 *
 * Every chat turn and every analyst answer inside it reserves AI credits on
 * the server, through a service the usage query never hears from. Without a
 * refresh at turn end the credits figure stays at its page-load value, which
 * reads as "credits are not being charged".
 */
export function watchTurnEnds(events: EventBus, onTurnEnd: () => void): () => void {
  let inTurn = false
  return events.on((event) => {
    if (event.type === 'state-change') {
      if (event.state === 'processing') {
        inTurn = true
      } else if (inTurn) {
        inTurn = false
        onTurnEnd()
      }
    } else if (event.type === 'error' && inTurn) {
      inTurn = false
      onTurnEnd()
    }
  })
}
